import React from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import { generateUrls } from '@hooks/usePublication'

const confirmDelete = (togglePublication) => {
  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Delete Assigned Publication?',
    })
    .then(({ value }) => {
      if (value){
        handleCallbackAction({ callbacks: { action: togglePublication }, toastText: 'Publication Unassigned' })
      }
    })
}

const AssignedPublicationListItem = (props) => {
  const {
    callbacks: {
      togglePublication,
    },
    publication,
  } = props

  const { id, title } = publication

  const { editPublicationUrl } = generateUrls(publication)

  return (
    <DashboardModuleListItem title={title}>
      <DashboardModuleListItem.TertiaryText>
        # {id}
      </DashboardModuleListItem.TertiaryText>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(togglePublication)}
          type="delete"
        />

        <DashboardModuleListItem.Icon
          href={`${editPublicationUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

AssignedPublicationListItem.propTypes = {
  callbacks: PropTypes.object.isRequired,
  publication: PropTypes.object.isRequired,
}

export default AssignedPublicationListItem
